import { useLayoutEffect, useRef } from 'react'
import { OrgChart } from 'd3-org-chart'
import { getRoleEnum, roleLabel } from '@types'

export const OrgChartComponent = (props: any, _ref: any) => {
  const d3Container = useRef<HTMLInputElement>(null)
  const chartRef = useRef(new OrgChart())

  // We need to manipulate DOM
  useLayoutEffect(() => {
    if (props.data && d3Container.current) {
      chartRef.current
        .container((d3Container.current as any) as string)
        .data(JSON.parse(JSON.stringify(props.data)))
        .nodeWidth(_d => 200)
        .nodeHeight(_d => 150)
        .compact(false)
        .expandAll()
        .nodeContent((node: any) => {
          return `<div style="
                padding: 1rem;
                border-radius: 0.5rem;
                border: 2px solid rgb(255, 135, 23);
                ">
                <div style="font-weight: bold; color: #461704;">${node.data.name}</div>
                <div style="color: #555;">💼 ${roleLabel[getRoleEnum(node.data.role)]}</div>
                <div style="color: #555;">🪪 ${node.data.document}</div>
                <div style="color: #555;">📞 ${node.data.phone}</div>
                <div style="color: #555;">🏛️ ${node.data.city?.toUpperCase()}</div>
                ${node.data.isComplete ? `<div style="color: #555;">✅${node.data.stages.office}</div>` : ''}
            </div>`
        })
        .onNodeClick(d => {
          props.onNodeClick(d)
        })
        .render()
    }
  }, [])

  return (
    <div>
      <div ref={d3Container} />
    </div>
  )
}
